import { render, staticRenderFns } from "./PromotionTabs.vue?vue&type=template&id=0236c0ae&"
import script from "./PromotionTabs.vue?vue&type=script&lang=js&"
export * from "./PromotionTabs.vue?vue&type=script&lang=js&"
import style0 from "./PromotionTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports